<template>
  <div>
    <div
      class="btn btn_lg btn_stroke-dark-soft btn_px-lg border-radius-md w-100"
      @click="showPopup()"
    >
      Оставить свой отзыв
    </div>

    <teleport to="#product-element__popup-container-vue">
      <transition name="fade">
        <div class="popup d-flex_middle popup_md-bottom" v-if="isShow">
          <div class="popup__layout" @click="closePopup()"></div>
          <div
            class="popup__wrap p-16 p-md-0 scroll scroll_y w-100 active-move-down"
            v-bind:class="{ 'is-active': isAnimate }"
          >
            <div
              class="popup__block popup__block_md bg-white border-radius-xl p-24 p-md-16 mx-auto"
            >
              <div class="grid-row">
                <div class="grid-col grid-col_full">
                  <div class="fs-28 fw-semibold fs-sm-20">Написать отзыв</div>
                </div>

                <div class="grid-col">
                  <div
                    class="btn color-gray hover-color-dark"
                    @click="closePopup()"
                  >
                    <Icon iconName="icon-close" className="icon-24" />
                  </div>
                </div>
              </div>

              <form>
                <div class="mt-20">
                  <div
                    class="rating rating_action d-inline-flex d-flex_reverse"
                  >
                    <div
                      class="rating__button rating__button_lg"
                      v-for="index in 5"
                      :key="index"
                      :class="activeIndex === index ? 'is-active' : ''"
                      @click="setReviewRating(index)"
                    >
                      <Icon iconName="icon-star" className="icon-full" />
                    </div>
                  </div>
                </div>

                <div class="mt-16">
                  <textarea
                    name="review"
                    :class="{ 'is-error': error }"
                    class="form-field form-field_text"
                    @input="error = false"
                    v-model="text"
                    required="required"
                    placeholder="Поделитесь вашими впечатлениями о товаре"
                  ></textarea>
                </div>

                <div v-show="error" class="mt-4 fs-14 color-negative">
                  Заполните поле отзыва
                </div>

                <div class="mt-16 color-tertiary fw-medium">
                  Добавьте до 3 фотографий
                </div>
                <div class="mt-8 color-gray">
                  до 3 фотографий формата JPG, JPEG, PNG не более 3 Мб
                </div>
                <div class="mt-8">
                  <File />
                </div>

                <div class="mt-32">
                  <button
                    class="btn btn_lg btn_primary border-radius-md btn_px-lg"
                    type="button"
                    @click="sendReview"
                  >
                    Отправить отзыв
                  </button>
                </div>
              </form>
            </div>
          </div>
          <!-- /popup__wrap -->
        </div>
      </transition>
    </teleport>
  </div>
</template>

<script>
import Icon from "../Icon/Icon.vue";
import File from "../File/File.vue";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { sendReview } from "@/pages/product_card/api/product.api";
import { useReviewsStore } from "@/pages/product_card/stores/store_reviews";
import { mapState } from "pinia";

export default {
  name: "PopupLeaveReview",
  components: {
    Icon,
    File,
  },
  data() {
    return {
      isShow: false,
      isAnimate: false,
      error: false,
      activeIndex: 1,
      rating: 5,
      text: "",
    };
  },
  setup() {
    const storeCatalog = useProductStore();
    const storeReviews = useReviewsStore();

    return {
      storeCatalog,
      storeReviews,
    };
  },
  computed: {
    ...mapState(useProductStore, ["getSelectedProduct"]),
    ...mapState(useReviewsStore, ["getWritten"]),
  },
  methods: {
    setReviewRating(index) {
      this.activeIndex = index;
      this.rating = 5 - (index - 1);
    },
    showPopup() {
      this.text = "";
      this.activeIndex = 1;
      this.rating = 5;

      this.isShow = true;
      setTimeout(() => {
        this.isAnimate = true;
      }, 2);
    },
    closePopup() {
      this.isAnimate = false;
      setTimeout(() => {
        this.isShow = false;
      }, 150);
    },
    async sendReview() {
      if (this.text.length === 0) {
        this.error = true;
        return;
      }

      const reviewResponse = await sendReview(
        this.getSelectedProduct.code,
        this.rating,
        this.text,
        this.getWritten.files
      );

      if (reviewResponse?.id > 0) {
        this.closePopup();
        this.storeReviews.reviewInProcess.sent = true;
      }
    },
  },
};
</script>
